export const BlankFiller = () => {
  return <div className="blank-filler"></div>;
};
